module.exports = __webpack_public_path__ + "img/image25.f293ba00.jpg";